import axios from '@/lib/axios';
import { PurchaseOrderContractTask, PurchaseOrderMember } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0800. 発注案件契約タスク編集
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_contract_tasks/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  id: number;
  contract_context_id: number;
  name: string;
  description?: string;
  due_date?: string;
  user_id: number;
};

const updatePurchaseOrderContractTask = (props: Props): Promise<PurchaseOrderContractTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/purchase_order_contract_tasks/${props.id}`,
    props
  );
};

export const useUpdatePurchaseOrderContractTask = () => {
  return useMutation({
    mutationFn: updatePurchaseOrderContractTask,
  });
};
